import { SVGIconType } from '../svgIcon';

export enum WordSelectionMode {
  SelectAllWords = 'SelectAllWords',
  HandpickKeywordsSuggestions = 'HandpickKeywordsSuggestions',
  HandpickKeywords = 'HandpickKeywords',
  AIPickWords = 'AIPickWords',
}

type WordSelectionModeDetailsType = {
  icon: SVGIconType;
  displayName: string;
  description: string;
  forQuickMemoryOnly: boolean;
};

export const WordSelectionModeDetails: Record<
  WordSelectionMode,
  WordSelectionModeDetailsType
> = {
  [WordSelectionMode.AIPickWords]: {
    icon: SVGIconType.AutoSelect,
    displayName: 'auto-change keywords',
    description: 'Automatically change keywords each play',
    forQuickMemoryOnly: true,
  },
  [WordSelectionMode.HandpickKeywordsSuggestions]: {
    icon: SVGIconType.WordSuggest,
    displayName: 'AI suggested keywords',
    description: 'Keywords suggested. Click any word to select or deselect',
    forQuickMemoryOnly: false,
  },
  [WordSelectionMode.HandpickKeywords]: {
    icon: SVGIconType.HandPickFill,
    displayName: 'Handpick keywords',
    description: 'Click any word to select or deselect',
    forQuickMemoryOnly: false,
  },
  [WordSelectionMode.SelectAllWords]: {
    icon: SVGIconType.SelectAll,
    displayName: 'Select all words',
    description: 'All words selected. Click any word to select or deselect',
    forQuickMemoryOnly: false,
  },
};
